import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { AssetUrlService } from '../services/basic/asset-url.service';

/**
 * Resolves an image URL via AssetUrlService.mediaUrl().
 * Usage: `[src]="url | storeImage | async"`
 */
@Pipe({
  name: 'storeImage',
  standalone: false,
})
export class StoreImagePipe implements PipeTransform {
  private assetUrlService = inject(AssetUrlService);

  transform(url: string | null | undefined): Observable<string> {
    if (!url) {
      return of('');
    }
    return from(this.assetUrlService.getCachedUrl(url));
  }
}
